// removed by extract-text-webpack-plugin
module.exports = {"popupBody":"PopupAttemptContact__popupBody___24Xyp","attemptedContact":"PopupAttemptContact__attemptedContact___mYGU2","plusSymbol":"PopupAttemptContact__plusSymbol___1m2z1","minusSymbol":"PopupAttemptContact__minusSymbol___G9HsJ","symbols":"PopupAttemptContact__symbols___20cfY","appointmentText":"PopupAttemptContact__appointmentText___1db1t","saveDiv":"PopupAttemptContact__saveDiv___3Qi_u","saveSpan":"PopupAttemptContact__saveSpan___1rtS1","date":"PopupAttemptContact__date___2JR5L","dateSpan":"PopupAttemptContact__dateSpan___5DBuX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupAttemptContact/PopupAttemptContact.css
// module id = 999
// module chunks = 0